package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_08_25_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Our heroes visit the Traveler’s Doorstep a legendary shop, which catches the eye with its distinctive lavender exterior and a peculiar shape — a triangular base, angled sides, and twist. Dirk wants an enchanted staff. Tuesday just wants something shiny. Annette is getting a quote on a Spyglass of Scrying. Goram gets a magical shield. Falorn leaves his crossbow with the shopkeeper to be enchanted.")
    }
}
